<div class="w-full text-slate-600 dark:text-slate-300 " [class]="shortShow?'mb-0':'mb-6 rounded-[7px] border  bg-lightCardBG dark:bg-darkCardBG border-lightMode-300 dark:border-darkMode-700 hover:shadow-site hover:shadow-lightMode-400 dark:hover:shadow-darkMode-700'">
    <div *ngIf="spiderChart.is_show_calculated_type" class="w-full px-2 my-4 pb-0">          
        <button *ngIf="getBackButton() && getBackButton()?.type=='quiz'" [routerLink]="getBackButton()?.url" (click)="scrollToTop()" class="flex items-center justify-center mb-3 text-sm bg-darkAccent border border-darkAccent mx-2 bg-opacity-20 rounded-md py-2 px-3 hover:bg-opacity-50" >
            <i class="fas fa-share ml-2"></i>
            <span>بازگشت به فرم</span>
        </button>                       
        <h2 *ngIf="!shortShow" class="text-center block text-[1.1rem] px-2 w-full font-normal text-lightMode-600 dark:text-darkMode-300">
            <span>{{user.name}}</span>  عزیز، تیپ شما
            <span class="text-lightMode-900 dark:text-white text-[1.5rem] inline-block font-tip direction-end">
                {{getCharType()}}
            </span> است.
        </h2>
        <div *ngIf="shortShow && exam" class="flex flex-col p-2 mx-2 items-start justify-between">
            <div class="flex items-start text-sm lg:text-xs justify-between w-full">
                <p class="mb-2">
                    <span class="text-lightMode-900 dark:text-white text-[1rem] font-tip">{{exam.name}}</span>
                </p>
                <p class="mb-2">
                    <span class="hidden lg:inline">تیپ : </span>
                    <span class="text-lightMode-900 dark:text-white text-[1.1rem] inline-block font-tip direction-end">
                        {{getCharType()}}
                    </span> 
                </p>
            </div>
            <div class="flex items-start justify-between w-full">
                <p class="mb-2 text-[0.8rem] text-lightMode-500 dark:text-darkMode-400">
                    <span class="text-lightMode-700 dark:text-darkMode-200">{{returnLastTakeExamDay(exam.given_at)|convertToPersian}}</span>
                    شرکت کرده است
                </p>
                <p class=" text-[0.8rem] text-lightMode-500 dark:text-darkMode-400">
                    <i class="fas fa-clock ml-1"></i>
                    <span>{{getTimePerMinutes(exam?.time.toString())|convertToPersian}}</span>
                </p>
            </div>
        </div>
    </div>
    
    <div [class]="shortShow?'':'mb-8 md:mb-12'" class="flex flex-col items-center justify-center w-full" [class]="shortShow ? 'mt-[60px]' : ''">
        <div class="flex items-center justify-center polar flex-row w-full min-h-auto relative">
            <highcharts-chart 
            [Highcharts]="Highcharts" 
            [options]="chartOptions" 
            style="width: 100%; display: block;" [style]="shortShow?'height:300px':'height:400px'" class="w-full 2xl:w-[75%] md:mx-auto flex items-center justify-center">
            </highcharts-chart>
            <div [class]="shortShow ? 'hidden' : 'hidden 2xl:flex'" class="absolute left-2 top-0 bottom-0 my-auto items-center justify-center flex-row pie">
                <div class="mx-2 hidden md:flex items-start justify-center flex-col p-2 rounded-[10px] bg-slate-200 dark:bg-slate-700">
                    <div *ngFor="let chart of chartLIst" class="flex mb-2 mt-1 items-center justify-between w-full flex-row">
                        <p class="text-sm text-lightMode-800 dark:text-darkMode-200 font-normal mx-1">
                            <span class="mx-1">(٪ {{chart.score.toString()|convertToPersian }})</span>
                            <span>{{chart.show}}</span>
                        </p>
                        <div [style]="{'background-color':chart.color}" class="w-4 h-4 rounded-[6px] mx-1"></div>
                    </div>
                    
                </div>
            </div>
    
        </div>
        <div [class]="shortShow ? 'hidden' : 'flex 2xl:hidden'" class="my-2 mb-6 items-center justify-center p-2 rounded-[10px] bg-slate-200 dark:bg-slate-700 mx-auto w-[90%] md:w-[88%]">
            <div class="grid grid-cols-4 gap-3 w-full mx-2 my-2">
                <div *ngFor="let chart of chartLIst" class="col-span-2">
                    <div class="col-span-2 w-full">
                        <div class="grid grid-cols-7">
                            <div [style]="{'background-color':chart.color}" class="w-4 sm:w-6 h-4 sm:h-6 rounded-[6px] mr-1 col-span-1"></div>
                            <div class=" col-span-6 text-[0.85rem] sm:text-sm md:text-lg text-lightMode-800 dark:text-darkMode-200 font-normal inline flex-row w-[calc(100% - 1rem)] break-words" >
                                <p class="mx-1 inline">
                                    {{outputType=='PERCENTAGE'?'%':''}}
                                    {{chart.score.toString()|convertToPersian }}</p>
                                <p class="inline">{{" "+chart.charType.type_explain}}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
